var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketwhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 2.9C5.75 2.81716 5.81716 2.75 5.9 2.75H8.75947C8.88713 4.42811 10.2892 5.75 12 5.75C13.7108 5.75 15.1129 4.42811 15.2405 2.75H18.1C18.1828 2.75 18.25 2.81716 18.25 2.9V21.1C18.25 21.1828 18.1828 21.25 18.1 21.25H15.2405C15.1129 19.5719 13.7108 18.25 12 18.25C10.2892 18.25 8.88713 19.5719 8.75947 21.25H5.9C5.81716 21.25 5.75 21.1828 5.75 21.1V2.9ZM5.9 1.25C4.98873 1.25 4.25 1.98873 4.25 2.9V21.1C4.25 22.0113 4.98873 22.75 5.9 22.75H9.3C9.82467 22.75 10.25 22.3247 10.25 21.8V21.5C10.25 20.5335 11.0335 19.75 12 19.75C12.9665 19.75 13.75 20.5335 13.75 21.5V21.8C13.75 22.3247 14.1753 22.75 14.7 22.75H18.1C19.0113 22.75 19.75 22.0113 19.75 21.1V2.9C19.75 1.98873 19.0113 1.25 18.1 1.25H14.7C14.1753 1.25 13.75 1.67533 13.75 2.2V2.5C13.75 3.4665 12.9665 4.25 12 4.25C11.0335 4.25 10.25 3.4665 10.25 2.5V2.2C10.25 1.67533 9.82467 1.25 9.3 1.25H5.9ZM8.5 11.25C8.08579 11.25 7.75 11.5858 7.75 12C7.75 12.4142 8.08579 12.75 8.5 12.75H15.5C15.9142 12.75 16.25 12.4142 16.25 12C16.25 11.5858 15.9142 11.25 15.5 11.25H8.5Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketwhite);
export default __webpack_public_path__ + "static/media/ticketwhite.44b8bcda8e8380e0bd951a774d78ac4e.svg";
export { ForwardRef as ReactComponent };